import React, { FC, createElement } from "react";
import marked from "marked";

interface CommentaryProps {
  comment: string;
}

const Commentary: FC<CommentaryProps> = ({ comment }) => {
  const html = marked(comment);

  const renderHTML = (rawHTML: string) => createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
  return <>{renderHTML(html)}</>;
};

export default Commentary;
